<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    placement="right"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- 材料项 -->
      <a-form-model-item label="材料项" prop="materialItemId">
        <a-select v-model="form.materialItemId" placeholder="请选择材料项" allow-clear style="width: 100%">
          <a-select-option v-for="item in materialItemList" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 定价类型 -->
      <a-form-model-item label="定价类型" prop="pricingType">
        <a-radio-group button-style="solid" v-model="form.pricingType">
          <a-radio-button :value="0">固定</a-radio-button>
          <a-radio-button :value="1">自定义</a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <!-- 状态 -->
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <!-- 固定价格 -->
      <a-form-model-item label="固定价格" prop="price" v-if="form.pricingType === 0">
        <a-input v-model="form.price" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>

      <!-- 自定义价格 -->
      <a-form-model-item label="最小定价" prop="priceMin" v-if="form.pricingType === 1">
        <a-input v-model="form.priceMin" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>
      <a-form-model-item label="最高定价" prop="priceMax" v-if="form.pricingType === 1">
        <a-input v-model="form.priceMax" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>

      <!-- 排序 -->
      <a-form-model-item label="排序号" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>

      <!-- 按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj, fetchMaterialItemList } from '@/api/repairModule/productMaterials'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      submitLoading: false,
      formTitle: '',
      materialItemList: [],
      form: {
        id: undefined,
        materialItemId: undefined,
        pricingType: 0,
        price: 0,
        priceMin: 0,
        priceMax: 0,
        sort: 99,
        status: 1,
        prodSkuId: undefined,
      },
      rules: {
        materialItemId: [{ required: true, message: '请选择材料项', trigger: 'change' }],
        pricingType: [{ required: true, message: '请选择定价类型', trigger: 'change' }],
        price: [
          {
            required: true,
            message: '请输入固定价格',
            trigger: 'blur',
          },
          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: '固定价格须为数字，最多两位小数',
            trigger: 'blur',
          },
        ],
        priceMin: [
          {
            validator: (_, v, cb) => {
              if (this.form.pricingType !== 1) return cb()
              if (v === '' || v == null) return cb(new Error('请输入最小定价'))
              if (!/^\d+(\.\d{1,2})?$/.test(v)) return cb(new Error('最小定价须为数字，最多两位小数'))
              if (Number(v) >= Number(this.form.priceMax)) return cb(new Error('最小定价必须小于最高定价'))
              cb()
            },
            trigger: ['blur', 'change'],
          },
        ],
        priceMax: [
          {
            validator: (_, v, cb) => {
              if (this.form.pricingType !== 1) return cb()
              if (v === '' || v == null) return cb(new Error('请输入最高定价'))
              if (!/^\d+(\.\d{1,2})?$/.test(v)) return cb(new Error('最高定价须为数字，最多两位小数'))
              if (Number(v) <= Number(this.form.priceMin)) return cb(new Error('最高定价必须大于最小定价'))
              cb()
            },
            trigger: ['blur', 'change'],
          },
        ],
        sort: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
    }
  },
  created() {
    this.loadMaterialItemList()
  },
  methods: {
    /* 对外暴露：新增 */
    handleAdd(prodSkuId) {
      this.reset()
      if (prodSkuId) {
        this.form.prodSkuId = prodSkuId
      }
      this.open = true
      this.formTitle = '新增维修产品项材料定价'
    },
    /* 对外暴露：修改 */
    handleUpdate(row) {
      this.reset()
      getObj(row.id).then((res) => {
        this.form = {
          ...res.data,
          // 确保数字字段正确转换
          price: res.data.price ? Number(res.data.price) : 0,
          priceMin: res.data.priceMin ? Number(res.data.priceMin) : 0,
          priceMax: res.data.priceMax ? Number(res.data.priceMax) : 0,
          sort: res.data.sort || 99,
          status: res.data.status || 1,
        }
        this.open = true
        this.formTitle = '修改维修产品项材料定价'
      })
    },
    /* 关闭前确认 */
    onCloseConfirm(done) {
      this.$confirm({ content: '数据未保存，确定关闭？', onOk: done })
    },
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    reset() {
      this.form = {
        id: undefined,
        materialItemId: undefined,
        pricingType: 0,
        price: 0,
        priceMin: 0,
        priceMax: 0,
        sort: 99,
        status: 1,
        prodSkuId: undefined,
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true

        // 准备提交数据
        const submitData = { ...this.form }

        // 根据定价类型清理不需要的字段
        if (submitData.pricingType === 0) {
          submitData.priceMin = undefined
          submitData.priceMax = undefined
        } else {
          submitData.price = undefined
        }

        const api = submitData.id ? putObj : addObj
        api(submitData)
          .then(() => {
            this.$message.success(submitData.id ? '修改成功' : '新增成功')
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    /* 加载材料项下拉 */
    loadMaterialItemList() {
      fetchMaterialItemList({
        pageNum: 1,
        pageSize: 999,
        status: 1, // 只加载启用的材料项
      }).then((res) => {
        this.materialItemList = res.data.records || []
      })
    },
  },
}
</script>

<style scoped>
.bottom-control {
  text-align: center;
  margin-top: 20px;
}
</style>
